import React, { useState } from "react";
import PropTypes from "prop-types";
import { PagedMenuContextProvider } from "./PagedMenuContext";
import MenuPage from "./MenuPage";

export function PagedMenu({ initialPage, children }) {
  const [currentPage, changePage] = useState(initialPage);

  return (
    <PagedMenuContextProvider value={{ changePage, currentPage }}>
      {children}
    </PagedMenuContextProvider>
  );
}

PagedMenu.Page = MenuPage;

PagedMenu.propTypes = {
  initialPage: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

PagedMenu.displayName = "PagedMenu";

export default PagedMenu;
